import React, { useEffect, useState } from 'react'
import AddButton from '../../../../component/AddButton'
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import { getBranchList, getDiscardSeedMovementsList } from '../../services/api'
import InputSearch from '../../../../component/InputSearch'
import dayjs from 'dayjs'
import ListLayout from '../../../../component/listLayout'

export default function StockCulledList() {
    const [branchs, setBranchs] = useState([])
    const [loading, setLoading] = useState(false)

    const { profile } = useSelector(state => state.profile)

    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || ''
    let t = searchParams.get('t') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    const [rowsPerPage] = useState(10);

    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getDiscardSeedMovementsList(q, b, t, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [q, b, t, page, rowsPerPage])
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        getBranch()
    }, [])
    const head = [
        'ที่',
        'ศูนย์เมล็ดพันธุ์ข้าว',
        'ประเภทเอกสาร',
        'วันที่เอกสาร',
        'เลขที่เอกสาร',
        'ประเภทเมล็ดพันธุ์',
        'สถานะ',
        'ดำเนินการ',
    ]
    const body = data?.items?.map((x, i) => {

        return {
            id: x?.DocumentNo,
            item1: (data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i,
            item2: x?.BranchNo?.BranchName,
            item3: x?.DocumentType,
            item4: dayjs(x?.DocumentDate).format('DD/MM/BBBB'),
            item5: x?.DocumentNo,
            item6: x?.SeedCategory,
            item7: x?.Status === 'C' ? <span class="status-draft">
                ปิด
            </span> :
                x?.Status === 'Y' ?
                    <span class="status-active">
                        เสร็จสิ้น
                    </span> : x?.Status === 'N' ?
                        <span class="status-inactive">
                            ยกเลิก
                        </span> : '',

            item8: [<Link to={`/stock/stock-culled/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, b: b, t: t })}>
                <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
            </Link>]
            ,


        }
    })
    return (
        <ListLayout title={'รายการเมล็ดพันธุ์คัดออก'} action={<>
            <AddButton link={'/stock/stock-culled/add'} />
            {
                profile?.BranchNo?.BranchNo === '00' &&
                <Box className="col-lg-2 col-md-12 ">
                    <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                        <FormControl variant="standard" fullWidth >
                            <Select value={b || 'all'}
                                onChange={e => setSearchParams({ q: q, b: e.target.value, t: t })}
                                disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                <MenuItem value='all'>ทั้งหมด</MenuItem>
                                {branchs?.map((x, i) => (
                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </Box >
            }
            <Box className="col-lg-2 col-md-12 ">
                <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                    <FormControl variant="standard" fullWidth >
                        <Select value={t || 'all'}
                            onChange={e => setSearchParams({ q: q, b: b, t: e.target.value })}
                            disableUnderline
                            MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                        >
                            <MenuItem value='all'>ประเภทเอกสารทั้งหมด</MenuItem>
                            <MenuItem value='รับ'>รับ</MenuItem>
                            <MenuItem value='จ่าย'>จ่าย</MenuItem>

                        </Select>
                    </FormControl>
                </Box>
            </Box >
            <InputSearch value={q} onChange={e => setSearchParams({ q: e.target.value, b: b, t: t })} placeholder={"ค้นหา เลขที่เอกสาร"} />
        </>} loading={loading} head={head} body={body} pagination={{
            count: data?.meta?.totalPages,
            page: +page,
            event: { q: q, b: b, id: id, t: t } 
        }} id={id} setSearchParams={setSearchParams}/>
    )
}
